module.exports = __webpack_public_path__ + "static/img/icon_bg1_zh.34241c5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon_bg1_zh.png
// module id = O01v
// module chunks = 0